import { Component, OnInit, Input, SimpleChanges, OnChanges, EventEmitter, Output, Inject, OnDestroy, forwardRef } from '@angular/core';
import { FormGroup, FormControl, Validators} from '@angular/forms';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles 
} from './models/control';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid'
import { FieldModel } from './models/field'
import { ToolModel } from './models/tool';
import { Styles, ControlContainerStyles } from './models/style';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { isEqual, isNil, set } from 'lodash-es';
import { GridComponent, ELoadingStatus } from './components/grid.component';
import { BaseComponent } from './components/base.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { FootprintManager_ShellService } from './FootprintManager.shell.service';
import { FootprintManager_OperationService } from './FootprintManager.operation.service';
import { FootprintManager_DatasourceService } from './FootprintManager.datasource.index';
import { FootprintManager_FlowService } from './FootprintManager.flow.index';
import { FootprintManager_ReportService } from './FootprintManager.report.index';
import { FootprintManager_LocalizationService } from './FootprintManager.localization.service';
import { FootprintManager_material_catalogs_project_subscribers_grid_ComponentContextService } from './FootprintManager.material_catalogs_project_subscribers_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './FootprintManager.frontend.types'
import { $frontendTypes as $types} from './FootprintManager.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IFootprintManager_material_catalogs_project_subscribers_gridComponentEntity {
  ProjectId?: number, MaterialCatalogId?: number, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, materials?: { material_count?: number }}

interface IFootprintManager_material_catalogs_project_subscribers_gridComponentInParams {
  catalog_id: number}


class FootprintManager_material_catalogs_project_subscribers_gridComponentRowModel extends GridRowModel {
  grid: FootprintManager_material_catalogs_project_subscribers_gridComponent;
  entity: IFootprintManager_material_catalogs_project_subscribers_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    Project_LookupCode: null,
    Project_Name: null,
    Project_Owner_LookupCode: null,
    Project_Owner_Name: null,
    materials_material_count: null,
  }



  constructor(
    grid: FootprintManager_material_catalogs_project_subscribers_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: FootprintManager_ShellService,
private $datasources: FootprintManager_DatasourceService,
private $flows: FootprintManager_FlowService,
private $reports: FootprintManager_ReportService,
private $localization: FootprintManager_LocalizationService,
private $operations: FootprintManager_OperationService,
private $logger: CleanupLoggerService,
private $context: FootprintManager_material_catalogs_project_subscribers_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.Project_LookupCode = new GridCellModel(
      new CellStyles(['grid-table-cell-link'], null),
      this.grid.headers.Project_LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Project_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Project_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Project_Owner_LookupCode = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Project_Owner_LookupCode,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.Project_Owner_Name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.Project_Owner_Name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.materials_material_count = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.materials_material_count,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IFootprintManager_material_catalogs_project_subscribers_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.ProjectId,this.entity.MaterialCatalogId].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IFootprintManager_material_catalogs_project_subscribers_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.ProjectId,this.entity.MaterialCatalogId].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = {};
    set($resultKey, 'ProjectId',this.entity.ProjectId);
    set($resultKey, 'MaterialCatalogId',this.entity.MaterialCatalogId);
    const inParams = {
      $keys:[$resultKey],
      catalog_id:  $grid.inParams.catalog_id ,
    };
    const data = await this.$datasources.Catalogs.ds_material_catalogs_project_subscribers_grid.getByKeys(inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns(inParams, data);
      
    this.entity = data.result[0] as IFootprintManager_material_catalogs_project_subscribers_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.Project_LookupCode.displayControl as TextModel).text = $row.entity.Project?.LookupCode;
    (this.cells.Project_Name.displayControl as TextModel).text = $row.entity.Project?.Name;
    (this.cells.Project_Owner_LookupCode.displayControl as TextModel).text = $row.entity.Project?.Owner?.LookupCode;
    (this.cells.Project_Owner_Name.displayControl as TextModel).text = $row.entity.Project?.Owner?.Name;
    (this.cells.materials_material_count.displayControl as TextModel).text = $row.entity.materials?.material_count?.toString();

  }

  override async refresh() {
    if (this.grid.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
      case 'Project_LookupCode' : {
        this.on_project_lookup();
        break;
      }
    }
  }

  //#region private flows
  on_project_lookup(event = null) {
    return this.on_project_lookupInternal(
      this,
  this.grid, this.$shell,
      this.$datasources,
      this.$flows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_project_lookupInternal(
    $row: FootprintManager_material_catalogs_project_subscribers_gridComponentRowModel,
  $grid: FootprintManager_material_catalogs_project_subscribers_gridComponent, 
    $shell: FootprintManager_ShellService,
    $datasources: FootprintManager_DatasourceService,
    $flows: FootprintManager_FlowService,
    $reports: FootprintManager_ReportService,
    $settings: SettingsValuesService,
    $operations: FootprintManager_OperationService,
    $utils: UtilsService,
    $context: FootprintManager_material_catalogs_project_subscribers_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: FootprintManager_LocalizationService,
    $event: any
  ) {
  
  
  let project_id = $row.entity.ProjectId;
  
  await $shell.FootprintManager.opensingle_project_hub({projectId: project_id});
  }
  //#endregion private flows

}


@Component({
  standalone: true,
  imports: [
    SharedModule,
  ],
  selector: 'FootprintManager-material_catalogs_project_subscribers_grid',
  templateUrl: './FootprintManager.material_catalogs_project_subscribers_grid.component.html'
})
export class FootprintManager_material_catalogs_project_subscribers_gridComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IFootprintManager_material_catalogs_project_subscribers_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('fitedWidth', ['compact','noscroll-table']);


  inParams: IFootprintManager_material_catalogs_project_subscribers_gridComponentInParams = { catalog_id: null };


  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     Project_LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'Project_LookupCode', 'Project lookup', false, false, null, false),       Project_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Project_Name', 'Project name', false, false, null, false),       Project_Owner_LookupCode: new GridHeaderModel(new HeaderStyles(null, null), 'Project_Owner_LookupCode', 'Owner lookup', false, false, null, false),       Project_Owner_Name: new GridHeaderModel(new HeaderStyles(null, null), 'Project_Owner_Name', 'Owner name', false, false, null, false),       materials_material_count: new GridHeaderModel(new HeaderStyles(null, null), 'materials_material_count', 'Material count', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: FootprintManager_material_catalogs_project_subscribers_gridComponentRowModel[] = [];

  @Input('catalog_id') set $inParams_catalog_id(value: any) {
    this.inParams['catalog_id'] = value;
  }
  get $inParams_catalog_id(): any {
    return this.inParams['catalog_id'] ;
  }

  topToolbar = {
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: FootprintManager_ShellService,
    private $datasources: FootprintManager_DatasourceService,
    private $flows: FootprintManager_FlowService,
    private $reports: FootprintManager_ReportService,
    private $localization: FootprintManager_LocalizationService,
    private $operations: FootprintManager_OperationService,
    private $logger: CleanupLoggerService,
    private $context: FootprintManager_material_catalogs_project_subscribers_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Material catalog project subscribers';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$checkRequiredInParams();
    if (!this.$hasMissingRequiredInParams) {
      this.$init();
    } else {
      this.$initEmpty();
    }
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$checkRequiredInParams();
      if(!this.$hasMissingRequiredInParams) {
        this.$init();
      } else {
        this.$initEmpty();
      }
    }
  }

  $missingRequiredInParams = [];
  get $hasMissingRequiredInParams(): boolean {
    return !!this.$missingRequiredInParams.length;
  }
  
  $checkRequiredInParams() {
    this.$missingRequiredInParams = [];
      if(isNil(this.inParams.catalog_id)) {
        this.$missingRequiredInParams.push('catalog_id');
      }
  }

  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 100;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    if (this.$hasMissingRequiredInParams) {
      return Promise.resolve(null);
    }
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const inParams = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      catalog_id:  $grid.inParams.catalog_id ,
    };
    try {
      const data = await this.$datasources.Catalogs.ds_material_catalogs_project_subscribers_grid.getList(inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns(inParams, data);

      this.entities = data.result as IFootprintManager_material_catalogs_project_subscribers_gridComponentEntity[];
      this.totalCount = data.totalCount;

      await this.$dataLoaded();
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new FootprintManager_material_catalogs_project_subscribers_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

  }

  
    async $applyLinkedDatasourcesAndCustomColumns(inParams: any, outParams: any) {
      const $datasource = { inParams: inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }


  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }



 
  close() {
    this.$finish.emit();
  }
}
